import dmi from './utils/deep-merge-inmutable';
import base from './base';
export default dmi(base, {
    message: {
        userActive: {
            cuil: "Cédula de identidad",
            cuils: "Cédulas de identidad",
        },
        search_text_1_1: "Cédula de identidad, Nombre, Apellido o Email",
        publishDocuments: {
            configIndivualPublish: {
                inputCuil: {
                    label: "Indentificador",
                    question: "¿Cuál es el Indentificador del colaborador?",
                    description: "Ingresa el Indentificador del colaborador al que quieres enviarle un documento"
                },
            }
        },
        certificates: {
            newCertificate: {
                personalInfo: {
                    dni: "Documento",
                },
                dni: "Documento"
            }
        },
        documentDetail: {
            commons: {
                cuil: 'Cédula de identidad',
            }
        }
    }
})